<template>
	<div
		class="site_button"
		:class="[theme, type]"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
		ref="site_button"
	>
		<span v-html="type === 'close' ? 'Close' : 'Menu'"></span>

		<div class='icon'>
			<svg
				v-if="type === 'close'"
				width="40"
				height="40"
				viewBox="0 0 40 40"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M21.4142 19.9999L39.5306 1.88345L38.1164 0.469238L20 18.5856L1.88357 0.469238L0.46936 1.88345L18.5858 19.9999L0.46936 38.1163L1.88357 39.5305L20 21.4141L38.1164 39.5305L39.5306 38.1163L21.4142 19.9999Z"
					fill="white"
				/>
			</svg>

			<svg
				v-if="type === 'open'"
				xmlns="http://www.w3.org/2000/svg"
				width="41"
				height="14"
				viewBox="0 0 41 14"
			>
				<g
					id="Hamburger"
					transform="translate(0 1)"
				>
					<line
						id="Line_2"
						data-name="Line 2"
						x2="41"
						transform="translate(0 12)"
						fill="none"
						stroke="#003c46"
						stroke-width="2"
					/>
					<line
						id="Line_1"
						data-name="Line 1"
						x2="41"
						fill="none"
						stroke="#003c46"
						stroke-width="2"
					/>
				</g>
			</svg>
		</div>

	</div>
</template>

<script>
import Close from '../../images/close_X.svg';
import Open from '../../images/menu.svg';

export default {
	data() {
		return {
			button_label: this.label,
			button_link: this.link,
			hovered: false,
			open: Open,
			close: Close,
		};
	},

	props: {
		label: {},
		theme: {
			default: 'light',
		},
		type: {
			default: 'normal',
		},
	},

	computed: {},

	watch: {
		link() {
			this.button_link = this.link;
		},
	},

	methods: {
		checkEmpty(e) {
			if (this.button_link.url === '#') {
				// this.$refs.site_button.removeAttribute('href');
				e.preventDefault();
			}
		},
	},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.site_button {
	display: inline-flex;
	flex-direction: column;
	transition: 0.2s ease all;
	text-decoration: none;
	justify-content: center;
	align-items: center;
	position: relative;
	border-radius: 0;
	background: transparent;
	align-items: center;
	gap: 10px;
	/* width: 40px;
	height: 40px; */

	.scrolled & {
		/* padding: 12px 24px 10px; */
		/* transform: scale(0.8); */
		transition: 0.2s ease all;
		padding-bottom: 0;
		flex-direction: row;
		align-items: center;

		span {
			color: var(--white);
			display: contents;
		}

		svg {
			display: flex;
			/* max-width: 24px;
			max-height: 12px; */
			/* margin-left: 8px; */
			transform: scale(0.7);

			&::v-deep {
				line {
					stroke: var(--white);
				}
			}
		}
	}

	@media (hover) {
		&:hover {
			transition: 0.2s ease all;
			cursor: pointer;

			span {
				transition: 0.2s ease all;
			}
		}
	}

	&:disabled {
		opacity: 0.5;
	}

	span {
		font: normal normal bold 12px/10px var(--primary-font-family);
		text-transform: uppercase;
		transition: 0.2s ease all;
		margin-right: 0;
		position: relative;
		z-index: 10;
		color: var(--white);
	}

	.icon {
		display: flex;
		justify-content: center;
		align-items: center;
		/* height: 23px; */
	}

	svg {
		display: flex;
		/* max-width: 24px;
		max-height: 12px;
		margin-left: 8px; */

		&::v-deep {
			line {
				stroke: var(--white);
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/MenuButton.vue